import Basemap from '@arcgis/core/Basemap';
import Collection from '@arcgis/core/core/Collection';
import OpenStreetMapLayer from '@arcgis/core/layers/OpenStreetMapLayer';
import TileLayer from '@arcgis/core/layers/TileLayer';

// Define basemap layers
const osmLayer = new OpenStreetMapLayer();

const usgsImageryOnly = new TileLayer({
  url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer'
});

const usgsShadedReliefOnly = new TileLayer({
  url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSShadedReliefOnly/MapServer'
});

const usgsTopo = new TileLayer({
  url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer'
});

const usgsHydroCached = new TileLayer({
  url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSHydroCached/MapServer'
});

// Create Basemap instances
const osmBasemap = new Basemap({
  baseLayers: [osmLayer],
  title: 'OpenStreetMap',
  id: 'osm'
});

const usgsImageryBasemap = new Basemap({
  baseLayers: [usgsImageryOnly],
  title: 'USGS Imagery Only',
  id: 'usgsImagery'
});

const usgsShadedReliefBasemap = new Basemap({
  baseLayers: [usgsShadedReliefOnly],
  title: 'USGS Shaded Relief Only',
  id: 'usgsShadedRelief'
});

const usgsTopoBasemap = new Basemap({
  baseLayers: [usgsTopo],
  title: 'USGS Topo',
  id: 'usgsTopo'
});

const usgsHydroCachedBasemap = new Basemap({
  baseLayers: [usgsHydroCached],
  title: 'USGS Hydro Cached',
  id: 'usgsHydroCached'
});

export const FREE_COMMERCIAL_BASEMAPS = new Collection([
  osmBasemap,
  usgsImageryBasemap,
  usgsShadedReliefBasemap,
  usgsTopoBasemap,
  usgsHydroCachedBasemap
]);

// Define available basemaps
export const ALL_BASEMAPS_TITLES = FREE_COMMERCIAL_BASEMAPS.map(
  (b) => b.title
).toArray();

export const defaultBasemap = osmBasemap;
